import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import FirstPage from '../pages/FirsPage.js/FirstPage';

function MainLayout() {
    return (
        <>
                <FirstPage />
            <main>
                <Outlet />
            </main>
            <Footer />
        </>
    );
}

export default MainLayout;
